export namespace ErrorCdsEnums {
    export enum errorcds {
        "INV_TRNS" = "One or more transformations are invalid.",
        "INV_ATTR_COND" = "One or more attribute(s) conditions are invalid.",
        "INV_FLTR_COND" = "Filter condition is invalid.",
        "INV_WHERE_CLAUSE" = "Filter condition is mandatory.",
        "INV_DBFUN_COND" = "Expression condition is invalid.",
        "INV_LNK_DTYP" = "One or more attribute(s) are invalid",
        "INV_CONNDB" = "Job should have Data Point and databases.",
        "INV_CONND" = "Job should have Data Point.",
        "INV_AGENT" = "Agent is Mandatory.",
        "INV_JOBS" = "One or more job(s) are invalid.",
        "INV_JNR_COND" = "Joiner condition is invalid.",
        "INV_SPLT_COND" = "Splitter condition is invalid.",
        "INV_DATAFLOW" = "Associated dataflow is invalid.",
        "INV_COND" = "Invalid Condition.",
        "NO_DATAPOINT" = "Invalid Condition.",
        "INV_LNK" = "Invalid link.",
        "INV_PARM" = "Invalid parameter(s).",
        "INV_SQL_PARM" = "Invalid sql parameter(s).",
        "INV_SQL_PARM_CONTEXT" = "SQL Parameter context is missing.",
        "INV_SQL_PARM_QUERY" = "SQL query is required.",
        "INV_DTYP_MISMATCH" = "invalid Datatype ",
        "INV_EXPR_CND" = "Expression condition invalid",
        "INV_DB_CMD_CND" = "DB Command condition is invalid",
        "INV_EMAIL_PTY" = "Email notification property value invalid",
        "INV_CONN" = "Native Datapoint is invalid",
        "INV_EMAIL_TO" = "Invalid Email To",
        "INV_EMAIL_CC" = "Invalid Email CC",
        "INV_EMAIL_SUB" = "Invalid Email subject",
        "INV_EMAIL_MSG" = "Invalid Email message",
        "EXPLODE_CHANGED" = "Invalid Attribute because explode is changed",
        "INV_DESRUI" = "Parent Datasubflow is Invalid",

        "NO_TRNS" = "No Transformation exists.",
        "NO_LOOP_END_IN_LNK" = "Loop start should have Loop end.",
        "NO_LOOP_START_OUT_LNK" = "Loop End should have Loop Start.",

        "INV_INLNK_CNT" = "Invalid In-link Count",
        "INV_OUTLNK_CNT" = "Invalid Out-link Count",

        "NO_IN_LNK" = "At least one in-link should be present.",
        "NO_ATTRS" = "At least one attribute is required",
        "NO_GRP_DER_ATTRS" = "At least one Group or Derived attribute should be present.",
        "NO_OUT_LNK" = "Atleast one out-link should be present.",
        "NO_SPLT_CNDS" = "At least one splitter condition should be present.",
        "NO_GRP_ATTRS" = "At least one group attribute should be present.",
        "NO_PARNT_DOBJ" = "Parent DataObject is not exists.",
        "NO_JOBS" = "No Job exists.",
        "NO_LATTRS" = "At least one LAttribute should be present.",
        "NO_ATTR_LNK" = "No attribute(s) links.",
        "NO_CONN_DBS" = "No database(s).",
        "NO_HOST" = "Data Point should have a host.",
        "NO_PORT" = "Data Point should have port.",
        "NO_TRUST_STORE_PATH" = "Data Point should have trust store path.",
        "NO_TRUST_STORE_PWD" = "Data Point should have trust store password.",
        "NO_CONN_APPUSR" = "Data Point must have App User",
        "NO_CONN_USER" = "Data Point should have user.",
        "NO_PASSWORD" = "Data Point must have a Password",
        "NO_DATABASE" = "Data Point must have at least one database",
        "NO_DATASET" = "Data Point should have one dataset.",
        "DATABASE_ALIAS_NM" = "Data Point should have database alias name.",
        "NO_SERVICE_NM" = "Data Point should have service name.",
        "NO_OWNER" = "Data Point should have one owner.",
        "NO_LIBRARIES" = "Data Point should have one librarie.",
        //		"NO_Agent"= "Data Point should have agent.",
        "NO_LATTR_LNK" = "Group attributes should have link.",
        "NO_PRIM_OBJ" = "No primary object.",
        "NO_KEYSPACE" = "Data Point should have one key space.",
        "NO_ACCOUNT" = "Data Point should have account",
        "NO_WRHLOC" = "Data Point should have one warehouse",
        "PROJ_ID" = "Data Point should have project id",
        "FILE_LOC" = "Data Point should have service account key file",
        "URL" = "Data Point should have webservices authentication url",
        "SEC_AUTH" = "Data Point should have authentication type",
        "DEST_NM" = "Data Point should have  webservices uri",
        "RESTAPI_URL" = "Data Point should have  REST API base url",
        "NO_TIMESPEC" = "Minimum of one timestampSpec selection",
        "NO_TIMESTAMP" = "Minimum of one timestamp datatype required",
        "NO_CLIENTID" = "Data Point should have client id",
        "NO_CLIENTKEY" = "Data Point should have client key",
        "NO_KEYSTORELOC" = "Data Point should have key store location",
        "NO_KEYSTOREPASS" = "Data Point should have key store password",
        "NO_JMS_PROVIDER" = "Data Point should have Channel Name",
        "NO_JMS_PROVIDER_URL" = "Data Point should have Queue Manager",
        "NO_SEVERNAME" = "Data Point should have server name",

        "CONN_TYPE" = "Data Point should have scope",
        "CONS_KEY" = "Data Point should have OAuth Client ID",
        "CONS_SEC" = "Data Point should have OAuth Client Secret",
        "CBK_URL" = "Data Point should have CallbackURL",

        "INV_CONN_SRC" = "  Datapoint is invalid.",
        "INV_CONN_TGT" = " Datapoint is invalid.",
        "NO_FTP_HOST" = "FTP Host details are mandatory",
        "NO_FTP_PORT" = "Data Point must have FTP Port details",
        "NO_FTP_CONN_USR" = "Data Point must have FTP user details",
        "NO_FTP_PASSWORD" = "Data Point must have FTP password",
        "NO_DATABASE_NM" = "Data Point should have database.",
        "NO_FILELOC" = "Data Point should have file location.",
        "NO_SFTP_HOST" = "Required SFTP host details.",
        "NO_SFTP_PORT" = "Data Point must have SFTP Port details",
        "NO_SFTP_CONN_USR" = "Data Point should have SFTP user.",
        "NO_SFTP_PASSWORD" = "Data Point should have SFTP password.",
        "NO_ZQH" = "Data Point should have Zookeeper Quorum host.",
        "CONSUMER_KEY" = "Data Point should have consumer key.",
        "CONSUMER_KEYSECRET" = "Data Point should have consumer secret.",
        "ACCESS_TOKEN" = "Data Point must have access token details",
        "REFRESH_TOKEN" = "Data Point must have refresh token details",
        "DEV_TOKEN" = "Data Point must have developer token details"
,        "ACCESS_TOKEN_SECRET" = "Data Point should have access token secret.",
        "APP_ID" = "Data Point should have app id.",
        "APP_SECRET" = "Data Point should have app secret.",
        "TRUST_STORE" = "Data Point should have trust store.",
        "TRUST_STORE_USER" = "Data Point should have trust store user.",
        "TRUST_STORE_PASSWORD" = "Data Point should have trust store password.",
        "KEY_STORE" = "Data Point should have key store.",
        "KEY_STORE_USER" = "Data Point should have key store user.",
        "KEY_STORE_PASSWORD" = "Data Point should have key store password.",
        "EXT_SERVICE_CMD" = "Data Point Should have external service command",
        "ACCESS_TOKEN_KEYNM" = "Data Point should have access token key name",
        "PROXY_HOST" = "Data Point should have Proxy Host.",
        "PROXY_PORT" = "Data Point should have Proxy Port.",
        "PROTOCOL" = "Data Point should have Protocol.",

        "AMAZON_S3_HOST" = "Data Point must have Amazon S3 URL details",
        "BUCKET_NM" = "Data Point must have Bucket Name",
        "ACCESS_KEY" = "Data Point should have access key.",
        "SECRET_KEY" = "Data Point must have secret key",

        "JMS_PROVIDER_URL" = "Data Point should have JMS provider url.",
        "DESTINATION_NM" = "Data Point should have destination Name.",
        "SOURCE_NM" = "Data Point should have source name.",
        "CONNECTION_FACTORY" = "Data Point should have Data Point factory.",
        "BOOTSTRAP_SERVERS" = "Data Point should have bootstrap servers.",
        "TOPIC" = "Data Point should have topic.",
        "KAFKA_REGEX" = "Data Point should have kafka regex.",

        "HIVE_PRINCIPAL" = "Data Point must have Hive principal",
        "USER_PRINCIPAL" = "Data Point must have User principal.",
        "SECKEYTAB" = "Data Point must have Key tab name.",
        "KDC_HOST" = "Data Point should have a  KDC host.",
        "DEFAULT_REALM" = "Data Point should have a  default realm.",

        "STORAGE_ACCNM" = "Data Point should have Storage Account Name",
        "STORAGE_ACCKEY" = "Data Point should have Key",
        "CONTAINER" = "Data Point should have Storage Container",

        "UDF_INV_CLS_NM" = 'UDF must have a class name',
        "UDFINVCLASSNAME" = 'UDF must have a class name',
        "UDF_INV_JAR" = 'UDF must have jar file',
        "UDF_INV_STX" = 'UDF must have syntax',
        "UDF_INV_M" = 'UDF must have UDF method',
        "UDF_QUAL_INV_CLS_NM" = 'UDF should have Fully Qualified Class Name/Method Name',

        "EMPT_COND" = "Empty condition.",
        "MIN_TWO_IN_LINKS" = "Minimum two in-links should be present.",
        "DFLOW_DLET" = "Associated DataFlow is not exist.",
        "DFLOW_NO_CONNDB" = "DesignJob is invalid because Data Point(s) is/are not present.",
        "DFLOW_INV_PARAMS" = "DesignJob Param(s) invalid",
        "PRE_SQL_INV" = "PreSQL condition is invalid.",
        "POST_SQL_INV" = "PostSQL condition is invalid.",
        "GCS_BUCKET_INV" = "GCS Bucket URI is required.",
        "DIST_BY_INV" = "Distributed by condition is invalid.",
        "TGT_NTV_DOBJ_INV" = "Target instance attributes are invalid",
        "TGT_MIN_ONE_MIN_LNK" = "Minimum of one Unique column selection.",
        "TGT_MIN_ONE_NON_UNQ" = "Minimum of one non-unique column mapping is mandatory.",
        "TGT_MIN_ONE_UNQ_SEL" = "Minimum of one Unique selection.",
        "TGT_MIN_ONE_INS_SEL" = "Minimum of one Insert selection.",
        "TGT_MIN_ONE_UPD_SEL" = "Minimum of one Update selection.",
        "TGT_MIN_ONE_SCD_SLET" = "Minimum one scd selection.",
        "TGT_SCD_SRT_COL" = "SCD start column is not selected",
        "TGT_SCD_END_COL" = "SCD end column is not selected",
        "TGT_SCD_CURR_IND_COL" = "scd current indicator is not defined.",
        "TGT_ATTR_NOT_MPD" = "Mandatory target attribute(s) is/are not mapped.",
        "TGT_UNQ_COL_NO_LNK" = "Unique key columns mapping is mandatory.",
        "TGT_DIST_UNQ_SEL" = "Distinct Uni_key is not defined.",
        "TGT_SCD_UNQ_SLET" = "Minimum one scd key and one unique should be selected .",
        "ONE_TGT_LNK_REQ" = "At least one target attribute must be mapped",
        "INV_OUT_ATTR" = "Invalidated as Output attribute(s) is/are not linked or datatype mismatched.",
        "ASSO_INV_DXMP" = "Associated Dataflow is invalid",
        "ASSO_DXMPI_DEL" = "Associated DataSubflow is Deleted",
        "PARENT_DOBJ_INV" = "Parent DataObject is Invalid",
        "NO_CONN" = "No datapoint Mapped",
        "NO_DATABASE_NAME" = "Data Point should have database name.",
        "NO_TNS" = "Data Point should have TNS alias.",
        "NO_WALLET_LOC" = "Data Point should have wallet location.",
        "TRUST_STORE_LOC" = "Data Point should have trust store location.",
        "SSL_VER" = "Data Point should have SSL Version.",
        "AUTO_MAP" = "ThougtSpot does not support partial columns mapping, need to map all attributes.",
        "NO_CONFIG" = "Data Point should have configuration file path",
        "NO_SCRIPT" = " Data Point script location should be provide ",
        "NO_DELAY" = "Data Point Delay Time should not be empty",
        "AUTH_PROG_LOC" = " Data Point Authentication Program Location should not be empty",
        "AUTH_KEY_LOC" = "Data Point Authentication Key File should not be empty",
        "HBASE_MASTER_PORT" = "Data Point should have OAuth authorization url",
        "HBASE_MASTER_HOST" = "Data Point should have OAuth accesstoken url",
        "FTPHOST" = "Data Point should have OAuth Callback url",


        "NO_SSL_MODE" = "Data Point should have SSL mode",
        "NO_SSL_CLIENT_CERT" = "Data Point should have SSL client certificate",
        "CLIENT_CERT" = "Data Point should have certificate",
        "NO_SSL_PWD" = "Data Point should have SSL password",
        "NO_SSL_KEY" = "Data Point should have SSL key",
        "NO_SSL_ROOT_CERT" = "Data Point should have SSL root certificate",


        //oracle
        "NO_SSL_KEYSTORE" = "Data Point should have SSL keystore",
        "NO_SSL_KEYSTOREPWD" = "Data Point should have SSL keystore password",
        "NO_SSL_TRUSTSTORE" = "Data Point should have SSL truststore",
        "NO_SSL_TRUSTSTOREPWD" = "Data Point should have SSL truststore password",
        "NO_SSL_PROTOCOL" = "Data Point sholud have SSL protocol",
        "NO_SSL_CIPHERSUITES" = "Data Point should have SSL Cipher Suites",
        "NO_SSL_VERSION" = "Data Point should have SSL version",

        //mysql
        "NO_SSLTRUSTCERT" = "Data Point should have SSL truststore",
        "NO_SSLTRUSTCERTPWD" = "Data Point should have SSL truststore password",
        "NO_SSLCLIENTCERT" = "Data Point should have SSL client certificate",
        "NO_SSLCLIENTCERTPWD" = "Data Point should have SSL client certificate password",

        "NO_BASE_DN" = "Data point should have Base DN",

        "RUN_AS_USR" = "Data point should have run as user details",

        //Scheduler
        "NO_FILE_DIR" = "Required file directory.",
        "NO_CMD" = "Required command.",
        "NO_FILE_MASK" = "Required file mask.",
        "NO_EMAIL_TO" = "Atleast one email_Id should be given.",
        "INV_EMAIL" = "Invalid email",
        "EMAIL_TO_INV_LEN" = "Email To Length is exceeds",
        "EMAIL_CC_INV_LEN" = "Email CC Length is exceeds",
        "SUBJ_INV_LEN" = "Subject Length is exceeds",
        "MSG_INV_LEN" = "Message Length is exceeds",
        "NO_EMAIL_SUBJECT" = "Required subject.",
        "NO_EMAIL_MSG" = "Empty message cannot be sent.",
        "NO_TASK_CMD_TYP_CD" = "Command type is required.",
        "NO_TASK_CMD_CD" = "Command is required.",
        "NO_TASK_FILE_DEPENDENT" = "Dependent file is required",
        "NO_TASK_CMD_CALENDAR" = "Calendar is required",
        "NO_TASK_CMD_CALENDAR_FREQUENCY" = "Calendar frequency is required",
        "INV_EMAIL_ACTION" = "Invalid Email Action",
        "INV_SCH_TASK_FILE_EVENT" = "Invalid File Event",
        "NO_WFCD" = "Week is required",
        "NO_MFCD" = "Month is required",
        "NO_MFCD_DAYS" = "Day is required",
        "NO_START_DATE" = "Start Date is required(dd-MMM-yyyy)",
        "NO_END_DATE" = "End Date is required(dd-MMM-yyyy)",
        "NO_START_TIME" = "Start Time is required(HH=MM)",
        "NO_END_TIME" = "End Time is required(HH=MM)",

        "INV_END_TIME" = "Invalid End Time(HH=MM)",
        "INV_START_DATE" = "Invalid Start Date(dd-MMM-yyyy)",
        "INV_END_DATE" = "Invalid End Date(dd-MMM-yyyy)",
        "INV_DATES" = "End Date shouldn't be less than Start Date.",
        "INV_START_TIME" = "End Time shouldn't be less than Start Time.",
        "PARAM_DEL" = "Param is deleted",
        "ITEM_DEL" = "Attribute or param is deleted",
        "INV_RETURN_TYP" = "Invalid Return type",
        "SCHEDULER_MANDITORY" = "Scheduler queue is mandatory",
        "NOT_SAME_FAMILY" = "Not same family",
        "NO_LNK_MAP" = "No link mapped",
        "INV_HAVING" = "Invalid Having Clause",
        "INV_LATTRS" = "One or more LAttribute(s) is not mapped",
        "INV_LATTRS_DTYP" = "One or more LAttribute(s) datatype is mismatched",
        "INV_LNK_COND" = "One or more link condition(s) are invalid",
        "DIST_SQL_INV" = 'Distributed by condition is invalid',
        "NO_WHITE_SPACE" = "App User should not contain white spaces",

        //Transpose
        "MIN_ONE_TNPS" = "Atleast one attribute must be selected as Transpose",
        "ONE_COLLAPSE" = "Select one attribute to collapse",
        "MIN_ONE_KEY" = "Atleast one attribute should be selected as key",

        //Office365
        "INV_SRC_CONN" = "Source Data Point is invalid",
        "INV_TGT_CONN" = "Target Data Point is invalid",


        //RestJob  connection validation
        "INV_REST_CONN" = "Rest Datapoint invalid.",
        "INV_FILE_CONN" = "File Datapoint invalid..",

        //For File_transfer Job
        "NO_UPLOADED_BY" = "Uploaded By is required",
        "NO_CLIENT_TIMESTAMP" = "Client Timestamp is required",
        "NO_JOB_NAME" = "Job Name is required",
        "NO_AUDIT_ID" = "Audit Id is required",
        "INV_LOOP_END_LNK" = "Invalid Loopend Link",
        "INV_LOOP" = "Invalid Looper",

        "IOTHUB_NAME" = "Data Point should have IoT connection string",
        "IOT_TOPIC" = "Data Point should have IoT Hub name",

        //Iceberg Trino
        "NO_MINIO_ENDPOINT" = "Minio endpoint should not be empty",
        "NO_METASTORE_URI" = "Metastore URI should not be empty",
        "NO_USERNAME" = "Username should not be empty",

//Rest API parameters
        "EMPTY_PARAMETERNAME" = "Parameter name should not be empty",
        "DUPLICATE_PARAMETERNAME" = "Parameter name should be unique",
	//MSSQL
        "NO_INSTANCE" = "Data Point should have instance.",
        "STM00003" = "One or more transforms are invalid.",
        "STM00008" = "DataObject Invalid due to Attribute have no links or Attribute",
        "STM00014" = "Target Inst invalid due to DataObject have no attributes.",
        "ESM00519" = "Transform database is not assigned to the Data Point.",
        //		"STM00015" = "Flagent is not set to Data Point/Command Job.",
        "STM00004" = "Associated Dataflow is invalid.",
        "STM00005" = "One or more job(s)/param(s) are invalid",
        "STM00012" = "Sequence or expression condition is Invalid.",
        "STM00002" = "Dependent DataObject is Deleted.",
        "STM00010" = "Dependent datapoint is Deleted.",
        "STM00006" = "Dependent DataFlow is Deleted.",
        "STM00023" = "Transform database is not assigned to the datapoint.",
        "STM00009" = "Data Point is Invalid",
        "ESM00202" = "Agent is mandatory.",
        "ESM00525" = "DataSubFlow is Deleted",
        "ESM00552" = "DataSubFlow is Invalid",
        "ESM00504" = "Invalid Calendar.",
        "ESM00505" = "Invalid Email Action(s).",
        "STM0006" = "Associated Dataflow is Deleted.",
        "ESM00533" = "Invalid Dependent task(s).",
        "ESM00537" = "Please select Source Data Point.",
        "ESM00538" = "Please select Target Data Point.",
        "STM00001" = "Attributes Links Deleted.",
        "ESM00540" = "In-link should be present.",
        "ESM00541" = "Atleast one database must be present for the datapoint.",
        "ESM00543" = "Cannot view data for Oracle and Exadata while importing.",
        "ESM00544" = "Unsaved Data Point(s) found, click SAVE.",
        "ESM00546" = "To Save the User with DataPreview Privilege User need to have any of Studio Privileges.",
        "ESM00557" = "Parent DataObject is Invalid.",
        "ESM00669" = "Please Select Rest Datapoint.",
        "ESM00670" = "Please Select File Datapoint.",
        "ESM00671" = "Datapoint should have Batch Size.",
        "ESM00672" = "Datapoint should have Time Out.",
        "ESM00673" = "Datapoint should have Application Name.",
        "ESM00674" = "Datapoint should have JSON credential File.",
        "ESM00675" = "Datapoint should have Agency ID.",
        "ESM00676" = "Datapoint should have Advertiser ID.",
        "ESM00677" = "Not Assign DatabaseName.",
        "ESM00678" = "Please select end date time range.",
        "ESM00679" = "Please select source data object.",
        "ESM00680" = "Selected source data object/dependent data point is invalid.",
        "ESM00681" = "Please select start date time range.",
        "STM00025" = " datapoint is invalid.",
        "STM00026" = " datapoint is invalid.",
        "STM00027" = "Number Of Parallel Instances should not be empty",
        "STM00028" = "Retry Attempts  should not be empty",

        "ESM00693" = "Associated datapoint agent is not assigned to project.",
        "SRC_AGNT_MSNG" = "Source associated datapoint agent is not assigned to project.",
        "TGT_AGNT_MSNG" = "Target associated datapoint agent is not assigned to project.",
        "STM00029" = "Retry wait time should not be empty",
        "STM00030" = "Invalid Command Event(s)",
        "ESM00700" = "Associated database not exists",
        "ESM00715" = "Connect Service is mandatory",
    }
}
